import DateUtils from './DateUtils';

const names = [
  'Emma',
  'Liam',
  'Olivia',
  'Noah',
  'Ava',
  'Isabella',
  'Sophia',
  'Jackson',
  'Lucas',
  'Mia',
  'Ethan',
  'Amelia',
  'Harper',
  'Evelyn',
  'Abigail',
  'Emily',
  'Benjamin',
  'Aiden',
  'James',
  'Charlotte',
  'Madison',
  'Ella',
  'Avery',
  'Scarlett',
  'Grace',
  'Chloe',
  'Lily',
  'Aria',
  'Ella',
  'Zoe',
  'Jackson',
  'Liam',
  'Lucas',
  'Logan',
  'Carter',
  'Mason',
  'Elijah',
  'Oliver',
  'Aiden',
  'Henry',
  'Wyatt',
  'Amelia',
  'Avery',
  'Evelyn',
  'Harper',
  'Mia',
  'Abigail',
  'Emily',
  'Ella',
  'Scarlett'
];

const lastNames = [
  'Smith',
  'Johnson',
  'Williams',
  'Jones',
  'Brown',
  'Davis',
  'Miller',
  'Wilson',
  'Moore',
  'Taylor',
  'Anderson',
  'Thomas',
  'Jackson',
  'White',
  'Harris',
  'Martin',
  'Thompson',
  'Garcia',
  'Martinez',
  'Robinson',
  'Clark',
  'Rodriguez',
  'Lewis',
  'Lee',
  'Walker',
  'Hall',
  'Allen',
  'Young',
  'Hernandez',
  'King',
  'Wright',
  'Lopez',
  'Hill',
  'Scott',
  'Green',
  'Adams',
  'Baker',
  'Nelson',
  'Carter',
  'Mitchell',
  'Perez',
  'Roberts',
  'Turner',
  'Phillips',
  'Campbell',
  'Parker',
  'Evans',
  'Edwards',
  'Collins',
  'Stewart'
];

export class Faker {
  static firstName() {
    const randomName = names[Math.floor(Math.random() * names.length)];

    return randomName;
  }

  static lastName() {
    const randomLastName =
      lastNames[Math.floor(Math.random() * lastNames.length)];

    return randomLastName;
  }

  static email(prefix = '') {
    const date = DateUtils.formattedDate({
      date: new Date(),
      applyTimezone: true,
      format: 'YYYYMDDhhmm'
    });

    return prefix + `${date}@twism.com`;
  }

  static password() {
    return 'Twism123';
  }
}
